import { Injectable } from '@angular/core';
import { IEditInDTO } from '../models/project/edit/edit-model';
import { ConfigurationService } from './configuration.service';
import { FunctionsHelperService, timeAgo } from './functions-helper.service';
import { PaymentStateManagerService } from './state-management/payment/payment-state-manager.service';
import { IExtendedProjectInDTO } from '../models/project/project-model';

@Injectable({
    providedIn: 'root',
})
export class ProjectCardService {
    basePath: string;

    constructor(
        public config: ConfigurationService,
        public helperFunctions: FunctionsHelperService,
        public paymentStateManager: PaymentStateManagerService
    ) {
        this.basePath = config.baseCdnUrl;
    }

    getLastProjectExportVideoUrl(edits: IEditInDTO[]) {
        const lastExport = this.getLastEdit(edits);
        return this.basePath + lastExport?.exports?.originalExported?.uploadPath;
    }
    getLastExportVideoTime(edits: IEditInDTO[]) {
        const lastExport = this.getLastEdit(edits);
        const lastExportedTime = new Date(lastExport.createdAt);
        return timeAgo(lastExportedTime.getTime());
    }
    getLastExportDuration(edits: IEditInDTO[]) {
        const lastExport = this.getLastEdit(edits);
        const fullVideoDuration = lastExport.videoEditTakes
            .map((editTake) => Math.round(editTake.take.duration))
            .reduce((duration, currentValue) => duration + currentValue, 0);
        return this.convertToMMSS(fullVideoDuration);
    }
    getProjectToDisplayBanner(project: IExtendedProjectInDTO) {
        const paymentStatus = this.paymentStateManager.getNeedToPayValue();
        return project.isPlayground && paymentStatus?.plan === 'immediate' && paymentStatus?.exportBehavior === 'none';
    }
    private getLastEdit(edits: IEditInDTO[]) {
        return edits?.filter((edit) => edit.exports?.originalExported?.uploadPath?.trim()).pop();
    }
    private convertToMMSS(duration: number): string {
        if (!duration || duration <= 0) return '00:00'; // Default if invalid

        const totalSeconds = Math.floor(duration / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
    }

    private padNumber(value: number): string {
        return value < 10 ? `0${value}` : `${value}`; // Ensure two-digit format
    }
}
